import { Link } from 'react-router-dom';
import { IoArrowForward, IoBookOutline, IoPeopleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';
import { seasonDates, seasonState } from '../../utils/season';
import './SeasonInvitation.css';

export default function SeasonInvitation({ season, isAuthenticated }) {
  const state = seasonState(season);
  const status = state?.phase === 'live' ? 'We’re reading together now'
    : state?.phase === 'ended' ? 'The season ends. The reading continues.'
      : state ? `Begins in ${state.days} ${state.days === 1 ? 'day' : 'days'}` : 'A shared invitation to Scripture';
  return (
    <section className={`season-invitation ${isAuthenticated ? 'season-invitation--member' : ''}`} aria-labelledby="season-title">
      <div className="season-copy">
        <p className="season-eyebrow">READTHEWORD / REFORMATION READING 2026</p>
        <p className="season-date">{seasonDates(season)} <span>{status}</span></p>
        <h1 id="season-title">One Word.{' '}<br />Many voices.{' '}<br /><em>Read together.</em></h1>
        <p className="season-intro">Open your Bible. Bring your family. Join your church.
          Every chapter you read is part of a bigger story: a community reading all of Scripture together.</p>
        <div className="season-actions">
          <Link className="season-button" to={isAuthenticated ? '/reading' : '/auth?view=register'}>
            {isAuthenticated ? 'Read the next chapter' : 'Join the 2026 reading'} <IoArrowForward aria-hidden="true" />
          </Link>
          {isAuthenticated ? <a className="season-text-link" href="#quick-log">Log what I read</a>
            : <Link className="season-text-link" to="/about">How it works <span aria-hidden="true">↗</span></Link>}
        </div>
        <p className="season-note">{isAuthenticated ? 'Your reading matters. One chapter is a good place to begin.' : 'Already reading with us?'} {!isAuthenticated && <Link to="/auth">Sign in to continue</Link>}</p>
      </div>
      <aside className="season-reading-card" aria-label="Our shared purpose">
        <div className="season-card-top"><IoBookOutline size={26} aria-hidden="true" /><span>THE WHOLE WORD.<br />THE WHOLE COMMUNITY.</span></div>
        <div className="season-scripture"><span className="season-quote-mark" aria-hidden="true">“</span><p>Thy word is a lamp unto my feet, and a light unto my path.</p><span>PSALM 119:105 · KJV</span></div>
        <div className="season-card-bottom"><strong>66 books. 1,189 chapters.</strong><p>A place for every reader.</p></div>
        <div className="season-book-lines" aria-hidden="true">{Array.from({ length: 22 }, (_, i) => <i key={i} />)}</div>
      </aside>
      {!isAuthenticated && <div className="season-steps" aria-label="How to participate">
        <div><IoBookOutline aria-hidden="true" /><p><strong>01 / Read or listen</strong><span>In your Bible or right here in the app.</span></p></div>
        <div><IoCheckmarkCircleOutline aria-hidden="true" /><p><strong>02 / Log your chapters</strong><span>A quick entry makes your reading count.</span></p></div>
        <div><IoPeopleOutline aria-hidden="true" /><p><strong>03 / See what we do together</strong><span>Follow your family, church, and community.</span></p></div>
      </div>}
    </section>
  );
}
